import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/**
 * Tiny admin-only "Edit" pill that appears next to a public page's H1.
 * Hidden for unauthenticated visitors. Links straight into the matching
 * admin panel (Pages / Articles / Products / Categories) with the record
 * pre-selected via the `?tab=…&slug=…` query params.
 *
 * Usage:
 *   <EditOnSiteLink type="page" slug={page.slug} />
 *   <EditOnSiteLink type="article" slug={article.slug} />
 *   <EditOnSiteLink type="product" slug={product.slug} />
 *   <EditOnSiteLink type="category" slug={cat.slug} />
 */
const TAB_BY_TYPE = {
  page: "pages",
  article: "articles",
  product: "products",
  category: "categories",
};

export default function EditOnSiteLink({ type, slug, label }) {
  const { user } = useAuth();
  if (!user || user === false || user.role !== "admin") return null;
  const tab = TAB_BY_TYPE[type];
  if (!tab || !slug) return null;
  return (
    <Link
      to={`/admin?tab=${tab}&slug=${encodeURIComponent(slug)}`}
      data-testid={`edit-on-site-${type}-${slug}`}
      title={`Edit this ${type} in admin`}
      className="brut bg-white pcs-text-pink hover:text-white hover:pcs-bg-pink inline-flex items-center gap-1.5 px-2 py-1 font-mono uppercase text-[10px] tracking-widest brut-press align-middle"
    >
      <Pencil className="w-3 h-3" strokeWidth={2.5} />
      {label || "Edit"}
    </Link>
  );
}
